const reducer = (state, { paymentCardId }) => ({
  ...state,
  deletingCards: [...state.deletingCards, paymentCardId],
});

export default reducer;
